// Типы пользовательских полей (контекст entities, ENT-UC-1, ENT-UC-4).
export enum FieldType {
  Text = 'text',
  LongText = 'longText',
  Number = 'number',
  Rating = 'rating',
  Boolean = 'boolean',
  Date = 'date',
  Url = 'url',
  Select = 'select',
  Reference = 'reference',
}

export const FIELD_TYPES: readonly FieldType[] = Object.values(FieldType);

export enum ReferenceTargetKind {
  Entity = 'entity',
  Post = 'post',
}

export interface ReferenceTarget {
  kind: ReferenceTargetKind;
  /** Для kind = entity — тип сущности, на записи которого ссылается поле. */
  entityTypeId?: string;
}

export interface FieldDefinition {
  /** Стабильный ключ (ENT-RULE-2), под ним хранится значение. */
  key: string;
  label: string;
  type: FieldType;
  required: boolean;
  /** Подсказка под полем в форме. */
  hint?: string;
  /** select: варианты выбора. */
  options?: string[];
  /** select и reference: можно выбрать несколько значений. */
  multiple?: boolean;
  /** reference: на что ссылается поле. */
  target?: ReferenceTarget;
}

export type FieldValue = string | number | boolean | string[] | null;
export type FieldValues = Record<string, FieldValue>;

export const FIELD_LABEL_MAX_LENGTH = 100;
export const FIELD_HINT_MAX_LENGTH = 300;
export const FIELD_OPTION_MAX_LENGTH = 100;
export const FIELD_OPTIONS_MAX_COUNT = 100;
export const FIELDS_MAX_COUNT = 50;
export const TEXT_MAX_LENGTH = 500;
export const LONG_TEXT_MAX_LENGTH = 20000;
export const RATING_MIN = 0.5;
export const RATING_MAX = 5;

export function isMultiValued(field: FieldDefinition): boolean {
  return (field.type === FieldType.Select || field.type === FieldType.Reference) && field.multiple === true;
}
